import { AfterViewInit, Component, Input, OnDestroy, SimpleChanges } from '@angular/core';
import { Chart } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
@Component({
  selector: 'pie-chart',
  templateUrl: './pie-chart-previdencia.component.html',
  styleUrls: ['./pie-chart-previdencia.component.css']
})
export class PieChartComponent implements AfterViewInit, OnDestroy {
  chart: any;
  @Input() valorTotal!: number;
  @Input() valorPatrocinadora!: number;
  @Input() valorRentabilidade!: number;
  @Input() valorParticipante!: number;
  @Input() valorPortabilidade!: number;
  @Input() idChart: any;
  @Input() titleChart!: string;
  @Input() yearSelected!: number;
  constructor() {
    Chart.register(ChartDataLabels);
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.RenderChart();
    }, 100);
  }
  ngOnDestroy(): void {
    this.chart.destroy();
  }
  RenderChart() {
    this.chart = new Chart(this.idChart, {
      type: 'pie',
      data: {
        labels:
          (this.valorPortabilidade) ?
            ['Valor Patrocinadora', 'Valor Participante', 'Valor Rentabilidade', 'Valor Portabilidade'] :
            ['Valor Patrocinadora', 'Valor Participante', 'Valor Rentabilidade'],
        datasets: [{
          label: 'R$',
          data:
            (this.valorPortabilidade) ?
              [this.valorPatrocinadora, this.valorParticipante, this.valorRentabilidade, this.valorPortabilidade] :
              [this.valorPatrocinadora, this.valorParticipante, this.valorRentabilidade],
          borderWidth: 1,
          backgroundColor: ['#FE7F2A', '#1A428A', '#007A47', '#F1AE2F'],
        }]
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            display: false,
          },
          datalabels: {
            anchor: 'end',
            align: 'end',
            formatter: (value) => {
              return Math.round((value / this.valorTotal) * 100) + '%';
            },
            font: {
              weight: 'bold',
              size: 12
            }
          }
        },
        layout: {
          padding: 30
        }
      },
    });
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['valorParticipante'].firstChange == false && changes['valorParticipante'].firstChange == false && changes['valorParticipante'].firstChange == false) {
      this.chart.destroy();
      this.RenderChart();
    }
  }
}
